import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { REPORT_USER, SPECIALTY_USER, SUPER_USER } from '../../actionTypes/Users/UserActionType';
import { logoutAccount } from '../../actions/Users/UserAction';
import { _setStorageTimeout } from '../../utils/helpers';
import { G_MSG_CHANNEL } from '../../routes/PRoute';
import { hideStatusMsg } from '../../actions/FlashMessage/FlashMessages';
import Api from '../../Api';

const MainNavDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.AppSession);
  const impersonating = useSelector((state) => state.Impersonate.impersonate.userPersonated);

  const signOut = () => {
    Api.instance.cancelAll();
    dispatch(logoutAccount());
    dispatch(hideStatusMsg());
    G_MSG_CHANNEL.postMessage({ action: 'logout' });
  };

  return (
    <UncontrolledButtonDropdown className="main-nav__dropdown">
      <DropdownToggle className={'main-nav__dropdown__btn'} caret aria-label="main-nav-dropdown">
        {userDetails.email}
      </DropdownToggle>
      <DropdownMenu>
        {![SPECIALTY_USER, REPORT_USER].includes(userDetails.userRole) && !impersonating && (
          <DropdownItem
            tag="a"
            onClick={() => {
              if (!impersonating) navigate('/users');
            }}
            active={location.pathname === '/users'}>
            Manage Users
          </DropdownItem>
        )}

        {userDetails.userRole === SUPER_USER && (
          <DropdownItem
            tag="a"
            onClick={() => {
              navigate('/messageUsers');
            }}
            active={location.pathname === '/messageUsers'}>
            Message Users
          </DropdownItem>
        )}

        <DropdownItem
          tag="a"
          onClick={() => {
            navigate('/settings');
          }}
          active={location.pathname === '/settings'}>
          Settings
        </DropdownItem>
        <DropdownItem
          tag={'a'}
          rel="noopener noreferrer"
          target="_blank"
          href="https://help.liaisonedu.com/Analytics_by_Liaison"
          aria-label="help">
          Help Center
        </DropdownItem>
        <DropdownItem tag="a" onClick={signOut}>
          Sign Out <i className="fas fa-sign-out-alt"></i>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );
};

export default MainNavDropdown;
